<div class="dropdown-container">
  <button type="button" class="selected-item" id="dropdownControl" (click)="toggle()" [attr.aria-expanded]="!isCollapsed">
    {{ selectedItem ? selectedItem.label : placeholder }}
    <app-icon [type]="iconType"></app-icon>
  </button>
  <div class="dropdown-items" *ngIf="!isCollapsed" aria-labelledby="dropdownControl">
    <button
      type="button"
      *ngFor="let item of items; trackBy: trackByFn"
      (click)="selectItem(item)"
      (keydown.enter)="selectItem(item)"
    >
      {{ item.label }}
    </button>
  </div>
</div>
